module.exports = __webpack_public_path__ + "static/media/student-end-season-prev.c65dfa99.png";